import React from "react";
import { Link } from "react-router-dom";
import { IoPeopleOutline, IoBriefcaseOutline, IoMailOutline, IoHeadsetOutline } from "react-icons/io5";
import "../Home.css";

export default function FaqSection({
  t,
  lang,
  showContactCard = true,
  hidePageTitle = false,
  pageLayout = false,
}) {
  const clientItems = t.faqClient || [];
  const businessItems = t.faqBusiness || [];
  const hasResults = clientItems.length > 0 || businessItems.length > 0;

  const contactCard = showContactCard && (
    pageLayout ? (
      <div className="faq-help-card scroll-animate from-bottom delay-2">
        <div className="faq-help-card__header">
          <span className="faq-help-card__header-icon" aria-hidden="true">
            <IoHeadsetOutline />
          </span>
          <h3 className="faq-help-card__title">{t.faqContactTitle}</h3>
        </div>
        <div className="faq-help-card__grid">
          <Link to="/contact" className="faq-help-card__btn faq-help-card__btn--email">
            <IoMailOutline className="faq-help-card__btn-icon" aria-hidden="true" />
            <span>{lang === "ar" ? "تواصل معنا" : "Contact us"}</span>
          </Link>
          <Link to="/support" className="faq-help-card__btn faq-help-card__btn--support">
            <IoHeadsetOutline className="faq-help-card__btn-icon" aria-hidden="true" />
            <span>{lang === "ar" ? "اسأل المساعد" : "Ask the assistant"}</span>
          </Link>
        </div>
      </div>
    ) : (
      <div className="faq-contact-card scroll-animate from-bottom delay-2">
        <h3 className="faq-contact-title">{t.faqContactTitle}</h3>
        <Link to="/contact" className="faq-contact-link">
          {lang === "ar" ? "تواصل معنا" : "Contact us"}
        </Link>
        <Link to="/support" className="faq-contact-link">
          {lang === "ar" ? "اسأل المساعد" : "Ask the assistant"}
        </Link>
      </div>
    )
  );

  const faqBlocks = (
    <div className="faq-blocks">
      {clientItems.length > 0 && (
        <div className="faq-block faq-block-client">
          <h3 className="faq-block-heading">
            <IoPeopleOutline className="faq-block-heading-icon" aria-hidden="true" />
            {t.faqClientTitle}
          </h3>
          <ul className="faq-list">
            {clientItems.map((item, idx) => (
              <li
                key={`client-${item.q}`}
                className={`faq-item scroll-animate from-bottom delay-${Math.min(idx + 2, 6)}`}
              >
                <details>
                  <summary className="faq-question">
                    <span className="fq-text">{item.q}</span>
                    <span className="fq-icon" aria-hidden="true" />
                  </summary>
                  <div className="faq-answer">
                    <div className="faq-answer-inner">
                      <p>{item.a}</p>
                    </div>
                  </div>
                </details>
              </li>
            ))}
          </ul>
        </div>
      )}

      {businessItems.length > 0 && (
        <div className="faq-block faq-block-business">
          <h3 className="faq-block-heading">
            <IoBriefcaseOutline className="faq-block-heading-icon" aria-hidden="true" />
            {t.faqBusinessTitle}
          </h3>
          <ul className="faq-list">
            {businessItems.map((item, idx) => (
              <li
                key={`business-${item.q}`}
                className={`faq-item scroll-animate from-bottom delay-${Math.min(idx + 2, 6)}`}
              >
                <details>
                  <summary className="faq-question">
                    <span className="fq-text">{item.q}</span>
                    <span className="fq-icon" aria-hidden="true" />
                  </summary>
                  <div className="faq-answer">
                    <div className="faq-answer-inner">
                      <p>{item.a}</p>
                    </div>
                  </div>
                </details>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  if (pageLayout) {
    if (contactCard) {
      return (
        <section className="faq-page-toolbar faq-page-toolbar--with-faqs" aria-label={t.faqTitle}>
          <div className="container">
            <div className="faq-help-card scroll-animate from-bottom delay-2">
              <div className="faq-help-card__header">
                <span className="faq-help-card__header-icon" aria-hidden="true">
                  <IoHeadsetOutline />
                </span>
                <h3 className="faq-help-card__title">{t.faqContactTitle}</h3>
              </div>
              <div className="faq-help-card__grid">
                <Link to="/contact" className="faq-help-card__btn faq-help-card__btn--email">
                  <IoMailOutline className="faq-help-card__btn-icon" aria-hidden="true" />
                  <span>{lang === "ar" ? "تواصل معنا" : "Contact us"}</span>
                </Link>
                <Link to="/support" className="faq-help-card__btn faq-help-card__btn--support">
                  <IoHeadsetOutline className="faq-help-card__btn-icon" aria-hidden="true" />
                  <span>{lang === "ar" ? "اسأل المساعد" : "Ask the assistant"}</span>
                </Link>
              </div>
              <div className="faq-help-card__faqs">
                {!hasResults && (
                  <p className="faq-no-results scroll-animate from-bottom delay-2">{t.faqNoResults}</p>
                )}
                {faqBlocks}
              </div>
            </div>
          </div>
        </section>
      );
    }

    return (
      <section className="faq-page-content" aria-label={t.faqTitle}>
        <div className="container">
          {!hasResults && (
            <p className="faq-no-results scroll-animate from-bottom delay-2">{t.faqNoResults}</p>
          )}
          {faqBlocks}
        </div>
      </section>
    );
  }

  return (
    <section
      className="faq-section container scroll-animate from-bottom"
      aria-labelledby={hidePageTitle ? undefined : "faq-title"}
    >
      {!hidePageTitle && (
        <>
          <h2 id="faq-title" className="home-section-title scroll-animate from-bottom delay-1">
            {t.faqTitle}
          </h2>
          <p className="faq-subtitle scroll-animate from-bottom delay-1-5">{t.faqSubtitleText}</p>
        </>
      )}

      {contactCard}

      {!hasResults && (
        <p className="faq-no-results scroll-animate from-bottom delay-2">{t.faqNoResults}</p>
      )}

      {faqBlocks}
    </section>
  );
}
